













































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: ['value'],
})
export default class StepDataUsage extends Vue {}
